<template>
    <div class="vx-col w-full mb-base flex">
      <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
        <vs-tab icon-pack="feather" icon="icon-refresh-cw" :label="!isSmallerScreen ? 'เรียกฟั่งชั่นดำเนินการ Mutation' : ''">
          <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
            <vx-card no-shadow>
              <vs-list>
                <vs-list-item title="คำนวนดอกเบี้ยรายวัน">
                  <vs-button type="line" line-origin="left" color="success" @click="callDailyCalculators()">เรียกฟั่งชั่น</vs-button>
                </vs-list-item>
                <vs-list-item title="คำนวนดอกเบี้ย EIR">
                  <vs-button type="line" line-origin="left" color="success" @click="callMonthlyEirCalculators()">เรียกฟั่งชั่น</vs-button>
                </vs-list-item>
                <vs-list-item title="สร้างผู้ใช้งานใหม่">
                  <vs-button type="line" line-origin="left" color="success" @click="callDailyCreateUserStudent()">เรียกฟั่งชั่น</vs-button>
                </vs-list-item>
                <vs-list-item title="คัดลอกข้อมูลผู้กู้ไปยังผู้ค้ำประกัน">
                  <vs-button type="line" line-origin="left" color="success" @click="callCreateSuretiesByBorrower()">เรียกฟั่งชั่น</vs-button>
                </vs-list-item>
                <vs-list-item title="อัพเดทข้อมูลหลักสูตร (ภายนอก)">
                  <vs-button type="line" line-origin="left" color="success" @click="callUpdateCurriculumExternalApi()">เรียกฟั่งชั่น</vs-button>
                </vs-list-item>
              </vs-list>
            </vx-card>
          </div>
        </vs-tab>
        <vs-tab icon-pack="feather" icon="icon-refresh-cw" :label="!isSmallerScreen ? 'รายงานดาวน์โหลด EXCEL' : ''">
          <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
            <vx-card no-shadow>
              <vs-list>
                <vs-list-item title="รายละเอียดสัญญา">
                  <a :href="`${reportServer}/excel/getContracts`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="รายละเอียดสัญญา (ปิดสัญญา)">
                  <a :href="`${reportServer}/excel/getContractsClose`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="สัญญาที่มียอดค้างชำระเพื่อส่ง SMS">
                  <a :href="`${reportServer}/excel/getContractsSendSms`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="สัญญาที่มีการชำระในวันปัจจุบัน">
                  <a :href="`${reportServer}/excel/getContractsPaymentNow`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="รายละเอียดที่อยู่สัญญา">
                  <a :href="`${reportServer}/excel/getContractAddress`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="รายละเอียดการติดตามหนี้ (โทร ส่งSMS ส่งเอกสาร ส่งฟ้อง)">
                  <a :href="`${reportServer}/excel/getTrackingHistory`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="รายละเอียดสัญญาแนบ">
                  <a :href="`${reportServer}/excel/getAttachedFile`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="รายละเอียดสัญญาผู้ค้ำประกัน">
                  <a :href="`${reportServer}/excel/getContractsSurety`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="รายละเอียดการติดตามหนี้สรุป">
                  <a :href="`${reportServer}/excel/getTrackingHistorySummary`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="รายละเอียดการตรวจสอบวันที่คาดว่าจะจบการศึกษา">
                  <a :href="`${reportServer}/excel/getContractsForecastDate`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="รายละเอียดการชำระเงินของเดือนก่อนหน้า">
                  <a :href="`${reportServer}/excel/getPaymentsLastMonth`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="รายละเอียดสถานะนักศึกษาและแผนเงินกู้">
                  <a :href="`${reportServer}/excel/getEducationStatusExternalAndPlan`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="รายละเอียดสถานะนักศึกษาและข้อมูลเงินกู้">
                  <a :href="`${reportServer}/excel/getEducationStatusExternalAndLoanInformation`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
                <vs-list-item title="รายละเอียดการชำระ (เพิ่มเติม)">
                  <a :href="`${reportServer}/excel/getPaymentsExtra`" target="_blank"><vs-button type="line" line-origin="left" color="success">ดาวน์โหลด</vs-button></a>
                </vs-list-item>
              </vs-list>
            </vx-card>
          </div>
        </vs-tab>
        <vs-tab icon-pack="feather" icon="icon-refresh-cw" :label="!isSmallerScreen ? 'ตั้งค่าระบบ' : ''">
          <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
            <vx-card no-shadow>
              <div class="mb-base">
                <h6 class="mb-4">ปิดปรับปรับปรุงระบบ (ชั่วคราว)</h6>
                <div class="flex items-center mb-4">
                  <vs-switch v-model="qrPayment.status" />
                  <span class="ml-4">ปิดปรับปรุงระบบดาวโหลด QR CODE</span>
                </div>
                <div class="flex items-center mb-4">
                  <vs-switch v-model="payment.status" />
                  <span class="ml-4">ปิดปรับปรุงระบบการชำระเงิน</span>
                </div>
              </div>
              <div class="mb-base">
                <h6 class="mb-4">ตั้งเวลาปิดปรับปรับปรุงระบบ</h6>
                <div class="items-center mb-4">
                  <div class="row mb-2">
                    <div class="col">
                      <span class="md-full">ปิดปรับปรุงระบบดาวโหลด QR CODE</span>
                      <div class="md-full flex">
                        <vs-input class="felx-1 mr-2" placeholder="Placeholder" v-model="qrPayment.start" />
                        <vs-input class="felx-1" placeholder="Disabled" v-model="qrPayment.end" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="md-full">ปิดปรับปรุงระบบชำระเงิน</span>
                      <div class="md-full flex">
                        <vs-input class="felx-1 mr-2" placeholder="Placeholder" v-model="payment.start" />
                        <vs-input class="felx-1" placeholder="Disabled" v-model="payment.end" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-wrap items-center justify-end mt-base">
                <vs-button class="ml-auto mt-2" @click="updateMaintenance">บันทึก</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning">คืนค่า</vs-button>
              </div>
            </vx-card>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
</template>

<script>
import { createNamespacedHelpers  } from 'vuex'
import { confirmCode } from '@/constants/config'
const { mapActions: mapSystemActions, mapState: mapSystemState } = createNamespacedHelpers('System')
const { mapActions: mapCustomerActions } = createNamespacedHelpers('Customer')
const { mapActions: mapMasterActions } = createNamespacedHelpers('Master')
export default {
  data() {
    return {
      loading: false,
      qrPayment: {
        id: "",
        status: true,
        start: "05.00",
        end: "22.45"
      },
      payment: {
        id: "",
        status: true,
        start: "05.00",
        end: "22.45"
      },
      reportServer: process.env.VUE_APP_REPORT_SERVER
    };
  },
  computed: {
    ...mapSystemState(['maintenances', 'status']),
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    },
  },
  async created () {
    const vm = this
    await vm.getMaintenances()
    this.initDate ()
  },
  methods: {
    ...mapCustomerActions(['createSuretiesByBorrower']),
    ...mapMasterActions(['updateCurriculumExternalApi']),
    ...mapSystemActions([
    'getContractAgingNinetyDay',
    'getContractNextRoundNull',
    'getContractTransactionNotUpdate',
    'getContractNextRoundFirstPrinciplePeriod',
    'getContractRepeatPayments',
    'getContractToBeFee',
    'dailyCalculators',
    'dailyCreateUserStudent',
    'monthlyEirCalculators',
    'getMaintenances',
    'updateMaintenances'
    ]),
    async callGetContractAgingNinetyDay(){
      const vm = this
      if(!vm.loading){vm.$vs.loading()}
      vm.loading = false
      const result = await vm.getContractAgingNinetyDay()
      console.log(result) // eslint-disable-line no-console
      await setTimeout(() => {
        vm.$vs.loading.close()
      }, 150)
    },
    async callGetContractNextRoundNull(){
      const vm = this
      if(!vm.loading){vm.$vs.loading()}
      vm.loading = false
      const result = await vm.getContractNextRoundNull()
      console.log(result) // eslint-disable-line no-console
      await setTimeout(() => {
        vm.$vs.loading.close()
      }, 150)
    },
    async callGetContractTransactionNotUpdate(){
      const vm = this
      if(!vm.loading){vm.$vs.loading()}
      vm.loading = false
      const result = await vm.getContractTransactionNotUpdate()
      console.log(result) // eslint-disable-line no-console
      await setTimeout(() => {
        vm.$vs.loading.close()
      }, 150)
    },
    async callGetContractNextRoundFirstPrinciplePeriod(){
      const vm = this
      if(!vm.loading){vm.$vs.loading()}
      vm.loading = false
      const result = await vm.getContractNextRoundFirstPrinciplePeriod()
      console.log(result) // eslint-disable-line no-console
      await setTimeout(() => {
        vm.$vs.loading.close()
      }, 150)
    },
    async callGetContractRepeatPayments(){
      const vm = this
      if(!vm.loading){vm.$vs.loading()}
      vm.loading = false
      const result = await vm.getContractRepeatPayments()
      console.log(result) // eslint-disable-line no-console
      await setTimeout(() => {
        vm.$vs.loading.close()
      }, 150)
    },
    async callGetContractToBeFee(){
      const vm = this
      if(!vm.loading){vm.$vs.loading()}
      vm.loading = false
      const result = await vm.getContractToBeFee()
      console.log(result) // eslint-disable-line no-console
      await setTimeout(() => {
        vm.$vs.loading.close()
      }, 150)
    },
    // mutation
    async callDailyCalculators(){
      const vm = this
      const inputCode = prompt("กรุณากรอกรหัสยืนยัน เพื่อยืนยันการดำเนินการ", "");
      if (confirmCode == inputCode) {
        if(!vm.loading){vm.$vs.loading()}
        vm.loading = false
        const result = await vm.dailyCalculators()
        console.log(result) // eslint-disable-line no-console
        await setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async callMonthlyEirCalculators(){
      const vm = this
      const inputCode = prompt("กรุณากรอกรหัสยืนยัน เพื่อยืนยันการดำเนินการ", "");
      if (confirmCode == inputCode) {
        if(!vm.loading){vm.$vs.loading()}
        vm.loading = false
        const result = await vm.monthlyEirCalculators()
        console.log(result) // eslint-disable-line no-console
        await setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async callDailyCreateUserStudent(){
      const vm = this
      const inputCode = prompt("กรุณากรอกรหัสยืนยัน เพื่อยืนยันการดำเนินการ", "");
      if (confirmCode == inputCode) {
        if(!vm.loading){vm.$vs.loading()}
        vm.loading = false
        const result = await vm.dailyCreateUserStudent()
        console.log(result) // eslint-disable-line no-console
        await setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async callCreateSuretiesByBorrower(){
      const vm = this
      const inputCode = prompt("กรุณากรอกรหัสยืนยัน เพื่อยืนยันการดำเนินการ", "");
      if (confirmCode == inputCode) {
        if(!vm.loading){vm.$vs.loading()}
        vm.loading = false
        const result = await vm.createSuretiesByBorrower()
        console.log(result) // eslint-disable-line no-console
        await setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async callUpdateCurriculumExternalApi(){
      const vm = this
      const inputCode = prompt("กรุณากรอกรหัสยืนยัน เพื่อยืนยันการดำเนินการ", "");
      if (confirmCode == inputCode) {
        if(!vm.loading){vm.$vs.loading()}
        vm.loading = false

        vm.updateCurriculumExternalApi().then(async () => {
          setTimeout(() => {
            vm.$vs.loading.close()
          }, 150)
        })
      }
    },
    async print (id) {
      this.$router.push({ name: 'accounting-contract-Print', params: {id: id} })
    }, // viewDetail
    async viewContract (id) {
      this.$router.push({ name: 'accounting-contract-edit', params: {id: id} })
    },
    async viewDetail (id) {
      this.$router.push({ name: 'accounting-contract-detail', params: {id: id} })
    },
    async viewTransaction (id) {
      this.$router.push({ name: 'accounting-transaction-view', params: {id: id} })
    },
    async updateMaintenance () {
      const vm = this

      await vm.updateMaintenances({
        form:[
          {
            id: vm.qrPayment.id,
            maintenanceSystem: "QrPayment",
            start: vm.qrPayment.start,
            end: vm.qrPayment.end,
            status: (vm.qrPayment.status? "Disabled" : "Enabled")
          },
          {
            id: vm.payment.id,
            maintenanceSystem: "Payment",
            start: vm.payment.start,
            end: vm.payment.end,
            status: (vm.payment.status? "Disabled" : "Enabled")
          }
        ]
      })
    },
    initDate (){
      const qrPayment = this.maintenances.find(res => res.maintenanceSystem === "QrPayment")
      this.qrPayment = {
        id: qrPayment.id,
        status: qrPayment.status === "Disabled",
        start: qrPayment.start,
        end: qrPayment.end,
      }
      const payment = this.maintenances.find(res => res.maintenanceSystem === "Payment")
      this.payment = {
        id: payment.id,
        status: payment.status === "Disabled",
        start: payment.start,
        end: payment.end,
      }
    }
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
};
</script>

<style>

</style>
